import { defineMessages } from 'react-intl';
export default defineMessages({
  activateCardPlsRetry: {
    id: 'activateCard.plsRetry',
    defaultMessage: '操作失败，请重试',
  },
  activateCardSorry: {
    id: 'activateCard.Sorry',
    defaultMessage: '非常抱歉',
  },
  activateCardphoneIsBound: {
    id: 'activateCard.phoneIsBound',
    defaultMessage: '当前登陆手机号已与其他微信号绑定过',
  },
  activateCardactivateWithOtherPN: {
    id: 'activateCard.activateWithOtherPN',
    defaultMessage: '请使用对应微信号或其他手机号激活',
  },
  activateCarduseOtherPN: {
    id: 'activateCard.useOtherPN',
    defaultMessage: '使用其他手机号激活',
  },
  activateCardactivateFaild: {
    id: 'activateCard.activateFaild',
    defaultMessage: '非常抱歉，激活失败了',
  },
  activateCardReason: {
    id: 'activateCard.Reason',
    defaultMessage: '原因：',
  },
  activateCardRetry: {
    id: 'activateCard.Retry',
    defaultMessage: '重试',
  },
  activateCardCongratulations: {
    id: 'activateCard.Congratulations',
    defaultMessage: '恭喜',
  },
  activateCardwxCardActivated: {
    id: 'activateCard.wxCardActivated',
    defaultMessage: '您的微信会员卡已被成功激活',
  },
  activateCardtoCheckCard: {
    id: 'activateCard.toCheckCard',
    defaultMessage: '快去卡包中看看吧！',
  },
  activateCardusePNtoActivate: {
    id: 'activateCard.usePNtoActivate',
    defaultMessage: '您将使用以下手机号激活微信会员卡',
  },
  activateCardactivateTobindWx: {
    id: 'activateCard.activateTobindWx',
    defaultMessage: '激活后该手机号将与您的微信绑定',
  },
  activateCarduseOtherPNtoActivate: {
    id: 'activateCard.useOtherPNtoActivate',
    defaultMessage: '如果该手机号不是您的，请使用其他手机号激活',
  },
  activateCardtoActivate: {
    id: 'activateCard.toActivate',
    defaultMessage: '去激活',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/activate/index.js